import './index.scss'
$(".head li").eq(3).addClass("active")